// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TAVx6","title":"styles_title__mXckS","description":"styles_description__aTJQk","content":"styles_content__RUZ9O"};